module.exports = __webpack_public_path__ + "img/roi_high-profile_youth.a22abfde.jpg";